/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_Create_ButtonInputs */

const en_translation_merge_create_button = /** @type {(inputs: Translation_Merge_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Group`)
};

const fr_translation_merge_create_button = /** @type {(inputs: Translation_Merge_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creer le groupe`)
};

const de_translation_merge_create_button = /** @type {(inputs: Translation_Merge_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe erstellen`)
};

const it_translation_merge_create_button = /** @type {(inputs: Translation_Merge_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea gruppo`)
};

const ru_translation_merge_create_button = /** @type {(inputs: Translation_Merge_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать группу`)
};

const es_translation_merge_create_button = /** @type {(inputs: Translation_Merge_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear grupo`)
};

const zh_cn2_translation_merge_create_button = /** @type {(inputs: Translation_Merge_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建组`)
};

const ja_translation_merge_create_button = /** @type {(inputs: Translation_Merge_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループを作成`)
};

const hi_translation_merge_create_button = /** @type {(inputs: Translation_Merge_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह बनाना`)
};

const pt_pt2_translation_merge_create_button = /** @type {(inputs: Translation_Merge_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar grupo`)
};

/**
* | output |
* | --- |
* | "Create Group" |
*
* @param {Translation_Merge_Create_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_create_button = /** @type {((inputs?: Translation_Merge_Create_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Create_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_merge_create_button(inputs)
	if (locale === "de") return de_translation_merge_create_button(inputs)
	if (locale === "it") return it_translation_merge_create_button(inputs)
	if (locale === "ru") return ru_translation_merge_create_button(inputs)
	if (locale === "es") return es_translation_merge_create_button(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_merge_create_button(inputs)
	if (locale === "ja") return ja_translation_merge_create_button(inputs)
	if (locale === "hi") return hi_translation_merge_create_button(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_merge_create_button(inputs)
	return en_translation_merge_create_button(inputs)
});